<script>
import feather from 'feather-icons';
import FooterCopyright from './FooterCopyright.vue';
import { socialLinks } from '../../data/socialLinks';

export default {
	components: { FooterCopyright },
	data() {
		return {
			socials: socialLinks,
			// ICP 备案号（部署前替换为真实备案号）
			icpNumber: '湘ICP备2026038349号-1',
		};
	},
	mounted() {
		feather.replace();
	},
	updated() {
		feather.replace();
	},
};
</script>

<template>
	<footer class="container mx-auto">
		<div
			class="py-10 border-t-2 border-primary-light dark:border-secondary-dark"
		>
			<!-- Social links -->
			<!--
			<div class="flex justify-center items-center gap-6 mb-6">
				<a
					v-for="social in socials"
					:key="social.id"
					:href="social.url"
					target="_blank"
					rel="noopener noreferrer"
					:aria-label="social.name"
					class="text-ternary-dark dark:text-ternary-light hover:text-indigo-600 dark:hover:text-indigo-300 duration-500"
				>
					<i :data-feather="social.icon" class="w-5 h-5"></i>
				</a>
			</div>
			-->
			<!-- Copyright -->
			<FooterCopyright />

			<!-- ICP 备案号（链接至工信部备案管理系统） -->
			<div class="mt-4 flex justify-center">
				<a
					href="https://beian.miit.gov.cn/"
					target="_blank"
					rel="noopener noreferrer"
					class="font-general-regular text-sm text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-300 duration-500 flex items-center gap-1"
				>
					<i data-feather="shield" class="w-4 h-4"></i>
					{{ icpNumber }}
				</a>
			</div>
		</div>
	</footer>
</template>

<style scoped></style>
